module.exports = __webpack_public_path__ + "feedback.9a713904.svg";